import React, { useEffect } from 'react'
import Gadjet from '../images/gadjet.svg'
import ReportIcon from '@mui/icons-material/Report';
import SearchNot from '../images/searchNot.png'
import C from '../images/cow.svg'
import { CycloneOutlined, Sell, Sensors } from '@mui/icons-material'
import { Link, useLocation } from 'react-router-dom';
import { useGlobalContext } from './Context';
const SearchResult = ({data}) => {
    const {searchShow}=useGlobalContext()
  return (
    <>
    {searchShow&&<div className='searchResultCon'>
      {data&&data?.length?data.map((item,index)=>{
        const {earTagNumber,bodyNumber,neckLaceNumber,cattleLifeCycleTitle,cattleStatusTitle,sensor:{deviceCode}}=item
        return <Link to={`/listdam/${item.id}`}  key={index} className='searchItem'>
            <img src={C} width={110} height={110}/>
            <div className='d-flex justify-content-between'>
                <div className='m-2'>
                <div className='d-flex align-items-center'><div className='LogoFormT'><div><span>
                <Sell/>
                </span>
                    </div></div>  {earTagNumber}</div>
                <div className='d-flex align-items-center'>
            <div className='LogoFormT'><div><span>
                <Sell/>
                </span>
                    </div></div> 
                <span>  </span>
                  {bodyNumber} </div>
                
                </div>
                <div className='m-2'>
                <div className='d-flex align-items-center'>  <div className='LogoFormT'><div><span>
                <Sensors/>
                </span>
                    </div></div>{deviceCode}</div>
                {/* <div className='d-flex align-items-center'> <div className='LogoFormT'><div><span>
                <ReportIcon/>
                </span>
                    </div></div>{cattleStatusTitle}</div> */}
                {/* <div className='d-flex align-items-center'><div className='LogoFormT'><div><span>
                <CycloneOutlined/>
                </span>
                    </div></div>  {cattleLifeCycleTitle}</div> */}
                    <div className='d-flex align-items-center'> <div className='LogoFormT'><div><span>
                <Sell/>
                </span>
                    </div></div>           
    {neckLaceNumber?neckLaceNumber:'_'}</div>
                </div>
            </div>
        </Link>
      }):<div dir='rtl' className='d-flex gap-1 align-items-center justify-content-center'><img width={100} height={100} src={SearchNot}/><h5>چیزی پیدا نکردم!</h5></div>}
    </div>}
    </>
  )
}

export default SearchResult
